export default __webpack_public_path__ + "static/media/gameEnd.524eb194.mp3";